export const supportedFileTypes = [
  "text/plain",
  "text/vtt",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/xml",
  "text/xml",
];

export const videoFileTypes = ["video/mp4", "video/quicktime"];

export const documentFileTypes = [
      "text/plain",
      "text/vtt",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
      "text/csv",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/xml",
      "text/xml",
      "application/zip",
      "application/x-zip-compressed",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "image/png",
      "image/jpeg",
      "application/json",
];

export enum Artifact {
  Agent = "Agent",
  Task = "Task",
  Workflow = "Workflow",
  Tool = "Tool",
  Session = "Session"
}

export enum Operation {
  Create = "create",
  Update = "update",
}